var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCreditCardPayment = function SvgCreditCardPayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 122.88 78.22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.24 58h17v4.1h-17V58zm75.4-13a9.77 9.77 0 017.87 4 9.85 9.85 0 110 11.76A9.84 9.84 0 1186.64 45zm29.48 29.29a2.94 2.94 0 002.88-2.81V34H3.9v37.48a2.64 2.64 0 00.82 2 2.87 2.87 0 002 .85zM6.74 78.2a6.55 6.55 0 01-4.76-2 6.58 6.58 0 01-2-4.75V6.74A6.72 6.72 0 016.74 0h109.38a6.76 6.76 0 016.76 6.74v64.74a6.68 6.68 0 01-2 4.75 6.81 6.81 0 01-4.77 2H6.73zM3.9 14.56H119V6.73a2.75 2.75 0 00-.87-2 2.81 2.81 0 00-2-.87H6.74a2.8 2.8 0 00-2 .87 2.76 2.76 0 00-.82 2v7.83zM36.09 58h28.29v4.1H36.09V58z",
    fillRule: "evenodd"
  })));
};

export default SvgCreditCardPayment;